import {
  Component,
  EventEmitter, inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Model} from "survey-core";
import {SurveyModule} from "survey-angular-ui";

import {TemplateComponent} from "../template/template.component";
import {ModalConfig} from "../modal.config";
import {InlineSVGModule} from "ng-inline-svg-2";
import {surveyTheme} from "../../../survey-theme";
import * as moment from "moment/moment";
import * as _ from 'lodash';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'lcms-survey-viewer',
  standalone: true,
  imports: [CommonModule, SurveyModule, TemplateComponent, InlineSVGModule , SurveyModule ],
  templateUrl: './survey-viewer.component.html',
  styleUrls: ['./survey-viewer.component.scss'],
})
export class SurveyViewerComponent implements OnDestroy , OnInit{
  @Input() surveydata :any
  translateService = inject(TranslateService);
  @Output() surveyResponse = new EventEmitter<any>()
  model: Model;
  @ViewChild('modal') public modal: TemplateComponent;
  configModal: ModalConfig = {
    modalTitle: 'Questionnaire',
    dismissButtonLabel: 'Cancel',
    closeButtonLabel: 'Save',
  };

  ngOnInit() {
    this.initializeSurvey();
  }

  initializeSurvey() {
    const survey = new Model({
      "completedHtml": "<div style=\"max-width:640px;text-align:center;margin:16px auto;\">\n\n<div style=\"padding:0 24px;\">\n<h4>questionnaire terminé</h4>\n<p>Merci d'avoir repondu au questionnaire</p>\n</div>\n\n</div>\n",
      "completeText": this.translateService.instant('modal.send'),
      "pageNextText": 'Suivant',
      "pagePreviousText": "Précédent",
      pages: this.surveydata
    });
    survey.locale = "fr";
    survey.applyTheme(surveyTheme);
    survey.onComplete.add((sender, options) => {
      console.log(JSON.stringify(sender.data, null, 3));
      console.log(JSON.stringify(options));
      this.surveyResponse.emit(sender.data);
    });
    this.model = survey;
    // this.model.onComplete.add((sender, options) => {
    //   console.log(JSON.stringify(sender.data, null, 3));
    //   console.log(JSON.stringify(options));
    //   this.surveyResponse.emit(sender.data);
    // })
  }

  openSurvey() {
    this.initializeSurvey();
    this.modal.open();
  }

  ngOnDestroy() {
    this.model.onCompleting.clear();
  }


}
